export default function GolfIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="32" cy="48" rx="28" ry="12" fill="#2E7D32" />
      <ellipse cx="31" cy="46.5" rx="22" ry="8.5" fill="#7CCB54" />
      <ellipse cx="35" cy="47" rx="4.5" ry="2" fill="#0F1A0C" />
      <path d="M35 47V8" stroke="#F2F4F7" strokeWidth="2.6" />
      <path d="M36 9c6 1 10 3.5 16 3-4.5 2.5-9.5 6-16 5.5z" fill="#FF4A3A" />
      <circle cx="18" cy="45" r="5" fill="#F2F4F7" />
      <circle cx="16.4" cy="43.4" r="1.6" fill="#FFFFFF" />
      <path d="M8 49c2-1 4-1 5-.4" stroke="#2F8BFF" strokeWidth="2" />
    </svg>
  );
}
